import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=a5a11bac&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a11bac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5a11bac')) {
      api.createRecord('a5a11bac', component.options)
    } else {
      api.reload('a5a11bac', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=a5a11bac&scoped=true&", function () {
      api.rerender('a5a11bac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23LixZY8t6TPM/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports